import listenForClick from "./clickHandler";

export const CookieSelectCountry = "no_more_select_country";
export const CookieNoShowGdpr = "no_show_gdpr";
const CookiePrefenceOn = "gdpr_preference"; // UI display this as: performance tools
const CookieTrackingOn = "gdpr_tracking"; // UI display this as: functionality

let isOldGDPR = false;

export function setIsOldGDPR(){
	isOldGDPR = true;
}
export function preferenceOn(){
	if (isOldGDPR)
		return true;
	else
		return (getCookie(CookiePrefenceOn) == "1");
}

export function trackingOn(){
	if (isOldGDPR)
		return true;
	else
		return (getCookie(CookieTrackingOn) == "1");
}

export function setCookie(cname: string, cvalue: string, exdays = 365) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function delCookie(cname: string) {
	document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT" + ";path=/";
}

export function getCookie(cname: string) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function deleteAllCookies() {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT" + ";path=/";
    }
}

export function handleButtonGDPRBar(){
	let gdprDiv = document.querySelector(".mi-gdpr") as HTMLElement;
	if (gdprDiv){
		if (getCookie(CookieNoShowGdpr) == "1"){
			gdprDiv.classList.add("mi-display-none");
		}
		else{
			// Default action on gdpr buttons are just close this div
			let gdprBtns = document.querySelectorAll(".mi-gdpr-btn");
			gdprBtns.forEach(btn => {
				listenForClick(btn as HTMLElement, () => {
					gdprDiv.classList.add("mi-display-none");
				});
			});
		}

		handleAcceptRejectAll(gdprDiv);

		function handleButtonsInPopup(){
			setTimeout(() => { // Wait for popup appear
				//console.log("Handle accept reject and save");

				let popup = document.querySelector(".mi-cookie-policy-popup") as HTMLElement;

				let closeButton = popup.querySelector(".dialog-close-button") as HTMLElement;

				let buttonRow = popup.querySelector(".mi-accept-reject-btn-row") as HTMLElement;
				handleAcceptRejectAll(buttonRow, closeButton);

				let preferenceOnCheckbox = popup.querySelector("#mi-gdpr-preference-on") as HTMLInputElement;
				let trackingOnCheckbox = popup.querySelector("#mi-gdpr-tracking-on") as HTMLInputElement;
				
				// Update the checkbox:
				preferenceOnCheckbox.checked = preferenceOn();
				trackingOnCheckbox.checked = trackingOn();

				let saveButton = popup.querySelector(".mi-gdpr-save") as HTMLElement;
				listenForClick(saveButton, () => {
					if (!preferenceOnCheckbox.checked){
						delCookie(CookieSelectCountry);
						delCookie(CookieNoShowGdpr);
						delCookie(CookiePrefenceOn);
						delCookie(CookieTrackingOn);
					}
					else{
						setCookie(CookiePrefenceOn, "1");
						setCookie(CookieNoShowGdpr, "1");
					}
					
					if (!trackingOnCheckbox.checked){
						delCookie(CookieTrackingOn);
						delCookie("_ga");
						var cookieKey = "_gat_gtag_" + ((window as any).mi_ga_code as string).replace(/-/g, "_");
						//console.log(cookieKey);
						delCookie(cookieKey);
						delCookie("_gid");
					}
					else{
						setCookie(CookieTrackingOn, "1");
					}

					closeButton.click();
				});
			}, 10);
		}
		
		// When click on manage button, popup the gdpr details popup
		let manageBtns = document.querySelectorAll(".mi-gdpr-manage");
		let popupHolderA = document.querySelector(".mi-gdpr-manage-popup-holder a") as HTMLElement;
		
		if (popupHolderA){
			listenForClick(popupHolderA, () => {
				handleButtonsInPopup();
			});

			manageBtns.forEach(_manageBtn => {
				let manageBtn = _manageBtn as HTMLElement;

				listenForClick(manageBtn, () => {
					setTimeout(() => { // not sure why, need to set timeout.
						popupHolderA.click();
						handleButtonsInPopup();
					}, 10);
				});
			});
		}
	}
}

function handleAcceptRejectAll(parent: HTMLElement, mimicClickEle: HTMLElement = null) {
	const listenerOn = "listener-on";
	if (parent.getAttribute(listenerOn) != "1"){
		parent.setAttribute(listenerOn, "1");

		//console.log("Add listeners");

		let acceptAllBtns = parent.querySelectorAll(".mi-gdpr-accept-all");
		acceptAllBtns.forEach(acceptAllBtn => {
			listenForClick(acceptAllBtn as HTMLElement, () => {
				//console.log("Accept all");
				setCookie(CookieNoShowGdpr, "1");
				setCookie(CookiePrefenceOn, "1");
				setCookie(CookieTrackingOn, "1");
				if (mimicClickEle)
					mimicClickEle.click();
			});
		});

		let rejectAllBtns = parent.querySelectorAll(".mi-gdpr-reject-all");
		rejectAllBtns.forEach(rejectAllBtn => {
			listenForClick(rejectAllBtn as HTMLElement, () => {
				//console.log("Reject all");
				deleteAllCookies();
				if (mimicClickEle)
					mimicClickEle.click();
			}, false);		
		});
	}
}

